import { render, staticRenderFns } from "./NewProductPage.vue?vue&type=template&id=730d6900&"
import script from "./NewProductPage.vue?vue&type=script&lang=js&"
export * from "./NewProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports